<template>
	<div class="pages">
		<navTop></navTop>
		<div class="box">
			<li>
				<span>16、Cargo stowage condition at openyard/warehouse/barge/truck(货物堆放在露天堆场/仓库/驳船/卡车)</span>
				<span>{{ data2.jz101 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz102 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz103" />
			</li>
			<li>
				<span>17、Dunnage condition at openyard/warehouse/barge/truck(货物堆放在露天堆场/仓库/驳船/卡车的垫木情况)</span>
				<span>{{ data2.jz104 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz105 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz106" />
			</li>
			<li>
				<span>18、Dunnage size at openyard/warehouse/barge/truck(货物堆放在露天堆场/仓库/驳船/卡车的垫木尺寸情况)</span>
				<span>{{ data2.jz107 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz108 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz109" />
			</li>
			<li>
				<span>19、Lashing condition at openyard/warehouse/barge/truck（货物堆放在露天堆场/仓库/驳船/卡车的绑扎情况）</span>
				<span>{{ data2.jz110 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz111 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz112" />
			</li>
			<li>
				<span>20、Insert number of pieces and quantity stated on B/L or cargo manifest/contract number（提单数量/吨位/合同号）</span>
				<span>{{ data2.jz113 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz114 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz115" />
			</li>
			<li>
				<span>21、Cargo coveraged by tarpaulin/plastic sheeting（货物是否被防水雨布/彩条布覆盖）</span>
				<span>{{ data2.jz116 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz117 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz118" />
			</li>
			<li>
				<span>22、Please insert grade of goods（货物钢种规格）</span>
				<span>{{ data2.jz119 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz120 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz121" />
			</li>
			<li>
				<span>23、Please write name of manufacturer/shipper（工厂/发货方名字）</span>
				<span>{{ data2.jz122 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz123 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz124" />
			</li>
			<li>
				<span>24、Please write specification number（规格说明）</span>
				<span>{{ data2.jz125 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz126 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz127" />
			</li>
			<li>
				<span>25、Please write mill's order number（订单号）</span>
				<span>{{ data2.jz128 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz129 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz130" />
			</li>
			<li>
				<span>26、Insert time when INSPECTION commenced（预检开始时间）</span>
				<span>{{ data2.jz131 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz132 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz133" />
			</li>
			<li>
				<span>27、Insert time when INSPECTION completed（预检结束时间）</span>
				<span>{{ data2.jz134 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz135 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz136" />
			</li>
			<li>
				<span>28、please Insert surveyor name（检验员名字）</span>
				<span>{{ data2.jz137 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz138 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz139" />
			</li>
			<li>
				<span>29、Please write the name of the surveyor that perform the join tly survey（联合检验检验员名字）</span>
				<span>{{ data2.jz140 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz141 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz142" />
			</li>

			<li>
				<span>30、write the location of the inspection: name of factory /Terminal and address（工厂名称/码头名字/地址）</span>
				<span>{{ data2.jz143 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz144 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz145" />
			</li>
			<li>
				<span>31、Letter of protest against Producer（出具给工厂的抗议）</span>
				<span v-if="data2.jz146 == 1">yes</span>
				<span v-if="data2.jz146 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz147 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz148" />
			</li>
			<li>
				<span>32、Letter of protest against Stevedores/Terminal（出具给绑扎公司/码头的抗议）</span>
				<span v-if="data2.jz149 == 1">yes</span>
				<span v-if="data2.jz149 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz150 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz151" />
			</li>
			<li>
				<span>33、Letter of protest against receiver（出具给收货人的抗议）</span>
				<span v-if="data2.jz152 == 1">yes</span>
				<span v-if="data2.jz152 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz153 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz154" />
			</li>
			<li>
				<span>34、Details of the shipping mark/lable（唛头/标签情况）</span>
				<span v-if="data2.jz155 == 1">yes</span>
				<span v-if="data2.jz155 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz156 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz157" />
			</li>
			<li>
				<span>35、Number of shipping/lable marks（唛头/标签数量）</span>
				<span v-if="data2.jz158 == 1">yes</span>
				<span v-if="data2.jz158 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz159 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz160" />
			</li>
			<li>
				<span>36、Details of the color mark（颜色标记情况）</span>
				<span v-if="data2.jz161 == 1">yes</span>
				<span v-if="data2.jz161 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz162 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz163" />
			</li>
			<li>
				<span>37、Number of color marks（颜色标记数量）</span>
				<span v-if="data2.jz164 == 1">yes</span>
				<span v-if="data2.jz164 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz165 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz166" />
			</li>
			<li>
				<span>38、Silver Nitrate test carried out randomly with negative result（随机硝酸银测试结果呈阴性）</span>
				<span v-if="data2.jz167 == 1">yes</span>
				<span v-if="data2.jz167 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz168 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz169" />
			</li>
			<li>
				<span>39、cargo condition (缺陷-生锈）</span>
				<span v-if="data2.jz170 == 1">yes</span>
				<span v-if="data2.jz170 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz171 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz172" />
			</li>
			<li>
				<span>40、cargo condition (缺陷-刮擦）</span>
				<span v-if="data2.jz173 == 1">yes</span>
				<span v-if="data2.jz173 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz174 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz175" />
			</li>
			<li>
				<span>41、cargo condition (缺陷-变形/弯曲）</span>
				<span v-if="data2.jz176 == 1">yes</span>
				<span v-if="data2.jz176 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz177 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz178" />
			</li>
			<li>
				<span>42、cargo condition (缺陷-油污）</span>
				<span v-if="data2.jz179 == 1">yes</span>
				<span v-if="data2.jz179 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz180 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz181" />
			</li>
			<li>
				<span>43、cargo condition (缺陷-绑带断）</span>
				<span v-if="data2.jz182 == 1">yes</span>
				<span v-if="data2.jz182 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz183 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz184" />
			</li>
			<li>
				<span>44、cargo condition (缺陷-褶皱破损）</span>
				<span v-if="data2.jz185 == 1">yes</span>
				<span v-if="data2.jz185 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz186 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz187" />
			</li>
			<li>
				<span>45、cargo condition (缺陷-水湿）</span>
				<span v-if="data2.jz188 == 1">yes</span>
				<span v-if="data2.jz188 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz189 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz190" />
			</li>
		</div>
	</div>
</template>

<script>
import navTop from '../../components/navTop.vue';
export default {
	name: 'workStart2',
	components: {
		navTop
	},
	data() {
		return {
			data2: {}
		};
	},
	created() {
		if (!sessionStorage.getItem('uid')) {
			this.$router.push({ path: '/' });
		} else {
			this.id = this.$route.query.id;
			this.getSchedulejz();
		}
	},
	methods: {
		getSchedulejz() {
			let data = {
				id: this.id
			};
			this.$api.schedulejz(data).then(res => {
				console.log(res);
				if (res.result == 0) {
					this.data2 = res.data1;
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.pages {
	background: #3E414A;
	.box {
		width: 100%;
		margin: 50px auto;
		border: 1px solid rgba(0, 255, 255, 0.25);
		border-radius: 10px;
		padding: 45px 154px 38px 56px;
		box-sizing: border-box;
		box-shadow: 0 0 300px 100px #043138 inset;
		p {
			color: #00fff0;
			font-size: 25px;
			line-height: 1em;
			text-align: center;
			font-weight: bold;
			margin-bottom: 10px;
		}
		li {
			display: flex;
			flex-direction: column;
			padding-bottom: 20px;
			box-sizing: border-box;
			span:nth-child(1) {
				color: #00fff0;
				font-size: 24px;
				line-height: 1em;
			}
			span:nth-child(2) {
				font-size: 24px;
				color: #ffffff;
				line-height: 1em;
				padding-top: 15px;
				box-sizing: border-box;
			}
			img {
				margin-top: 15px;
				display: block;
				width: 392px;
				height: 292px;
				border-radius: 10px;
			}
		}
	}
}
</style>
